var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.news)?_c('div',{attrs:{"id":"news"}},_vm._l((_vm.news),function(item,key){return _c('NewsCard',{key:key,attrs:{"data":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }